module.exports = __webpack_public_path__ + "static/img/map-plane-left.fa5a331.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/map-plane-left.png
// module id = pmUO
// module chunks = 1